import script from "./ProjectAndTaskIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAndTaskIndex.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAndTaskIndex.vue?vue&type=style&index=0&id=1b9914b0&lang=css"
import "./ProjectAndTaskIndex.vue?vue&type=style&index=1&id=1b9914b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9914b0"]])

export default __exports__